/**
 * Supported UI locales.
 *
 * The app currently ships German only, but the whole i18n pipeline (message
 * files per locale, detection cascade, provider) is already locale-plural so
 * adding e.g. 'en' means: add `messages/en/*.json`, add the tag here — nothing
 * in the components changes.
 */
export const SUPPORTED_LOCALES = ['de'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'de';

export const LOCALE_STORAGE_KEY = 'mdenture.locale';

/**
 * Accepts any BCP-47 tag (e.g. "de-AT", "en-US") and returns the matching
 * supported base locale via prefix-match, or null if unsupported.
 */
export function normalizeLocale(value: string): Locale | null {
  const lower = value.toLowerCase();
  for (const locale of SUPPORTED_LOCALES) {
    if (lower === locale || lower.startsWith(`${locale}-`)) {
      return locale;
    }
  }
  return null;
}
